import tw from 'twin.macro'

export const Fieldset = tw.fieldset`w-full font-brand`

export const Legend = tw.legend`mb-8 text-default-emphasis font-semibold text-lg`

export const FieldsetContent = tw.div`space-y-6`
